// extracted by mini-css-extract-plugin
export var carrierTab = "_4n-0";
export var carrierTabActive = "_4n-1 _4n-0";
export var carrierTabInactive = "_4n-2 _4n-0";
export var carrierTabLabel = "_4n-3";
export var carrierTabLabelActive = "_4n-4 _4n-3";
export var carrierTabLabelInactive = "_4n-5 _4n-3";
export var carrierTabPercentage = "_4n-6";
export var carrierTabPercentageActive = "_4n-7 _4n-6";
export var carrierTabPercentageInactive = "_4n-8 _4n-6";
export var carrierTabWinnable = "_4n-9";
export var carrierTabWinnableActive = "_4n-a _4n-9";
export var carrierTabWinnableInactive = "_4n-b _4n-9";
export var comparisonContainer = "_4n-d";
export var missingRateButton = "_4n-n";
export var missingRateButtonActive = "_4n-o _4n-n";
export var missingRateButtonInactive = "_4n-p _4n-n";
export var missingRateButtonLabel = "_4n-q";
export var missingRateButtonLabelActive = "_4n-r _4n-q";
export var missingRateButtonLabelInactive = "_4n-s _4n-q";
export var sidebar = "_4n-c";
export var strategyButton = "_4n-e";
export var strategyButtonActive = "_4n-f _4n-e";
export var strategyButtonDescription = "_4n-k";
export var strategyButtonDescriptionActive = "_4n-l _4n-k";
export var strategyButtonDescriptionInactive = "_4n-m _4n-k";
export var strategyButtonInactive = "_4n-g _4n-e";
export var strategyButtonLabel = "_4n-h";
export var strategyButtonLabelActive = "_4n-i _4n-h";
export var strategyButtonLabelInactive = "_4n-j _4n-h";
export var unitToggleButton = "_4n-t";
export var unitToggleButtonActive = "_4n-u _4n-t";
export var unitToggleButtonInactive = "_4n-v _4n-t";
export var unitToggleButtonLabel = "_4n-w";
export var unitToggleButtonLabelActive = "_4n-x _4n-w";
export var unitToggleButtonLabelInactive = "_4n-y _4n-w";